//#region ../../packages/components/select/src/token.ts
const selectGroupKey = Symbol("ElSelectGroup");
const selectKey = Symbol("ElSelect");

//#endregion
export { selectGroupKey, selectKey };
//# sourceMappingURL=token.mjs.map